// Cuándo corresponde pedirle a la empresa que califique a Atlas en la tienda de apps de
// Tiendanube, a cambio de 10 imágenes — ADR-2026-10-12-premio-por-calificar-en-tiendanube.
//
// Va ANTES que la encuesta en la cadena de carteles de la home, y ya no la exige
// (ADR-2026-10-23-calificar-en-tiendanube-antes-que-la-encuesta): a quien tiene la tienda
// conectada y llegó al piso de creaciones se le pide primero la reseña. Reclamarla
// reevalúa la cadena (`dismissCalificarTiendanube`), así que la encuesta le aparece en el
// momento.
//
// La calificación no se puede verificar (Tiendanube no avisa), así que se premia el gesto:
// abrir la página y tocar "Hecho". Una vez por empresa: el candado es
// `company_profiles.calificacion_tiendanube_premiada` y lo pone el backend, que además
// vuelve a mirar estas mismas condiciones (`services/feedback/calificacionTiendanube.ts`
// en atlas-backend). Si cambia una, cambia en los dos lados.

/** La página de calificación de la app de Atlas en Tiendanube. */
export const URL_CALIFICAR_TIENDANUBE =
  'https://www.tiendanube.com/tienda-aplicaciones-nube/estudio-atlas/rating';

/** Imágenes de premio. El monto real lo decide el servidor y viaja en la respuesta. */
export const PREMIO_CALIFICAR_TIENDANUBE = 10;

/**
 * Hay que tener AL MENOS esto. Es el mismo piso que la encuesta y cuenta lo mismo: todas
 * las filas de `imagenes_generadas` de la empresa, videos y borradas incluidas.
 */
export const MINIMO_GENERADAS_PARA_CALIFICAR = 30;

/**
 * ¿Le toca ver el cartel de calificar?
 *
 * `generadas` y `premiada` en `null` = la consulta no se pudo hacer, y ahí NO sale: igual
 * que la encuesta, un cartel que aparece porque una lectura falló promete un premio sin
 * saber si corresponde.
 */
export function correspondeCalificarTiendanube(p: {
  esPago: boolean;
  /** Integración de Tiendanube activa en la empresa (no "Ahora no"). */
  tiendaConectada: boolean;
  /** `company_profiles.calificacion_tiendanube_premiada`, o `null` si no se pudo leer. */
  premiada: boolean | null;
  /** Filas de `imagenes_generadas` de la empresa, o `null` si el conteo falló. */
  generadas: number | null;
}): boolean {
  if (!p.esPago || !p.tiendaConectada) return false;
  if (p.premiada !== false) return false;
  if (p.generadas === null) return false;
  return p.generadas >= MINIMO_GENERADAS_PARA_CALIFICAR;
}
